import { Select, MenuItem, FormControl, InputLabel, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface CountryCode {
  name: string;
  code: string;
  dialCode: string;
  flag: string;
  phoneLength: number | [number, number]; // Single number or range
}

const countryCodes: CountryCode[] = [
  // Asia
  { name: 'India', code: 'IN', dialCode: '+91', flag: '🇮🇳', phoneLength: 10 },
  { name: 'China', code: 'CN', dialCode: '+86', flag: '🇨🇳', phoneLength: 11 },
  { name: 'Japan', code: 'JP', dialCode: '+81', flag: '🇯🇵', phoneLength: [10, 11] },
  { name: 'South Korea', code: 'KR', dialCode: '+82', flag: '🇰🇷', phoneLength: 10 },
  { name: 'Singapore', code: 'SG', dialCode: '+65', flag: '🇸🇬', phoneLength: 8 },
  { name: 'Malaysia', code: 'MY', dialCode: '+60', flag: '🇲🇾', phoneLength: 10 },
  { name: 'Indonesia', code: 'ID', dialCode: '+62', flag: '🇮🇩', phoneLength: 10 },
  { name: 'Thailand', code: 'TH', dialCode: '+66', flag: '🇹🇭', phoneLength: 9 },
  { name: 'Vietnam', code: 'VN', dialCode: '+84', flag: '🇻🇳', phoneLength: 9 },
  { name: 'Philippines', code: 'PH', dialCode: '+63', flag: '🇵🇭', phoneLength: 10 },
  { name: 'Pakistan', code: 'PK', dialCode: '+92', flag: '🇵🇰', phoneLength: 10 },
  { name: 'Bangladesh', code: 'BD', dialCode: '+880', flag: '🇧🇩', phoneLength: 10 },
  { name: 'Sri Lanka', code: 'LK', dialCode: '+94', flag: '🇱🇰', phoneLength: 9 },
  { name: 'Nepal', code: 'NP', dialCode: '+977', flag: '🇳🇵', phoneLength: 10 },
  { name: 'Maldives', code: 'MV', dialCode: '+960', flag: '🇲🇻', phoneLength: 7 },

  // Middle East
  { name: 'UAE', code: 'AE', dialCode: '+971', flag: '🇦🇪', phoneLength: 9 },
  { name: 'Saudi Arabia', code: 'SA', dialCode: '+966', flag: '🇸🇦', phoneLength: 9 },
  { name: 'Qatar', code: 'QA', dialCode: '+974', flag: '🇶🇦', phoneLength: 8 },
  { name: 'Kuwait', code: 'KW', dialCode: '+965', flag: '🇰🇼', phoneLength: 8 },
  { name: 'Bahrain', code: 'BH', dialCode: '+973', flag: '🇧🇭', phoneLength: 8 },
  { name: 'Oman', code: 'OM', dialCode: '+968', flag: '🇴🇲', phoneLength: 8 },
  { name: 'Israel', code: 'IL', dialCode: '+972', flag: '🇮🇱', phoneLength: 9 },
  { name: 'Turkey', code: 'TR', dialCode: '+90', flag: '🇹🇷', phoneLength: 10 },

  // Europe
  { name: 'United Kingdom', code: 'GB', dialCode: '+44', flag: '🇬🇧', phoneLength: [10, 11] },
  { name: 'Germany', code: 'DE', dialCode: '+49', flag: '🇩🇪', phoneLength: [10, 11] },
  { name: 'France', code: 'FR', dialCode: '+33', flag: '🇫🇷', phoneLength: 9 },
  { name: 'Italy', code: 'IT', dialCode: '+39', flag: '🇮🇹', phoneLength: 10 },
  { name: 'Spain', code: 'ES', dialCode: '+34', flag: '🇪🇸', phoneLength: 9 },
  { name: 'Netherlands', code: 'NL', dialCode: '+31', flag: '🇳🇱', phoneLength: 9 },
  { name: 'Belgium', code: 'BE', dialCode: '+32', flag: '🇧🇪', phoneLength: 9 },
  { name: 'Switzerland', code: 'CH', dialCode: '+41', flag: '🇨🇭', phoneLength: 9 },
  { name: 'Sweden', code: 'SE', dialCode: '+46', flag: '🇸🇪', phoneLength: 9 },
  { name: 'Norway', code: 'NO', dialCode: '+47', flag: '🇳🇴', phoneLength: 8 },
  { name: 'Denmark', code: 'DK', dialCode: '+45', flag: '🇩🇰', phoneLength: 8 },
  { name: 'Finland', code: 'FI', dialCode: '+358', flag: '🇫🇮', phoneLength: 9 },
  { name: 'Poland', code: 'PL', dialCode: '+48', flag: '🇵🇱', phoneLength: 9 },
  { name: 'Portugal', code: 'PT', dialCode: '+351', flag: '🇵🇹', phoneLength: 9 },
  { name: 'Greece', code: 'GR', dialCode: '+30', flag: '🇬🇷', phoneLength: 10 },

  // Americas
  { name: 'United States', code: 'US', dialCode: '+1', flag: '🇺🇸', phoneLength: 10 },
  { name: 'Canada', code: 'CA', dialCode: '+1', flag: '🇨🇦', phoneLength: 10 },
  { name: 'Mexico', code: 'MX', dialCode: '+52', flag: '🇲🇽', phoneLength: 10 },
  { name: 'Brazil', code: 'BR', dialCode: '+55', flag: '🇧🇷', phoneLength: [10, 11] },
  { name: 'Argentina', code: 'AR', dialCode: '+54', flag: '🇦🇷', phoneLength: 10 },
  { name: 'Chile', code: 'CL', dialCode: '+56', flag: '🇨🇱', phoneLength: 9 },
  { name: 'Colombia', code: 'CO', dialCode: '+57', flag: '🇨🇴', phoneLength: 10 },
  { name: 'Peru', code: 'PE', dialCode: '+51', flag: '🇵🇪', phoneLength: 9 },

  // Oceania
  { name: 'Australia', code: 'AU', dialCode: '+61', flag: '🇦🇺', phoneLength: 9 },
  { name: 'New Zealand', code: 'NZ', dialCode: '+64', flag: '🇳🇿', phoneLength: 9 },
  { name: 'Fiji', code: 'FJ', dialCode: '+679', flag: '🇫🇯', phoneLength: 7 },

  // Africa
  { name: 'South Africa', code: 'ZA', dialCode: '+27', flag: '🇿🇦', phoneLength: 9 },
  { name: 'Egypt', code: 'EG', dialCode: '+20', flag: '🇪🇬', phoneLength: 10 },
  { name: 'Nigeria', code: 'NG', dialCode: '+234', flag: '🇳🇬', phoneLength: 10 },
  { name: 'Kenya', code: 'KE', dialCode: '+254', flag: '🇰🇪', phoneLength: 9 },
  { name: 'Morocco', code: 'MA', dialCode: '+212', flag: '🇲🇦', phoneLength: 9 },
  { name: 'Ghana', code: 'GH', dialCode: '+233', flag: '🇬🇭', phoneLength: 9 },
];

// Phone validation utilities
export const validatePhoneNumber = (phone: string, countryCode: string): boolean => {
  const cleanPhone = phone.replace(/[\s\-()]/g, '');
  const country = countryCodes.find(c => c.dialCode === countryCode);
  
  if (!country) {
    // For unknown countries, just ensure it's a reasonable length
    return /^\d{7,15}$/.test(cleanPhone);
  }

  if (Array.isArray(country.phoneLength)) {
    const [min, max] = country.phoneLength;
    return cleanPhone.length >= min && cleanPhone.length <= max;
  }

  return cleanPhone.length === country.phoneLength;
};

export const getPhoneNumberPlaceholder = (countryCode: string): string => {
  const country = countryCodes.find(c => c.dialCode === countryCode);
  
  if (!country) {
    return 'Enter phone number';
  }

  if (Array.isArray(country.phoneLength)) {
    const [min, max] = country.phoneLength;
    return `${min}-${max} digit number`;
  }

  return `${country.phoneLength}-digit number`;
};

export const formatPhoneNumber = (phone: string, countryCode: string): string => {
  const cleanPhone = phone.replace(/[\s\-()]/g, '');
  return `${countryCode}${cleanPhone}`;
};

interface CountryCodeSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  fullWidth?: boolean;
}

const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: '8px',
  minWidth: '180px', // Increased minimum width
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[300],
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '8px 16px',
  minWidth: '250px', // Increased minimum width for menu items
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export default function CountryCodeSelect({ 
  value, 
  onChange, 
  label = 'Country Code', 
  required = false,
  fullWidth = true 
}: CountryCodeSelectProps) {
  const selectedCountry = countryCodes.find(country => country.dialCode === value) || countryCodes[0];

  return (
    <FormControl fullWidth={fullWidth} size="small">
      <InputLabel>{label}</InputLabel>
      <StyledSelect
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value as string)}
        required={required}
        renderValue={() => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span style={{ fontSize: '1.2rem' }}>{selectedCountry.flag}</span>
            <Typography>{selectedCountry.dialCode}</Typography>
          </Box>
        )}
      >
        {countryCodes.map((country) => (
          <StyledMenuItem key={country.code} value={country.dialCode}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
              <span style={{ fontSize: '1.2rem' }}>{country.flag}</span>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Typography>{country.name}</Typography>
                <Typography color="text.secondary">{country.dialCode}</Typography>
              </Box>
            </Box>
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}

export { countryCodes }; 